import { Typography } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Disclaimer as DisclaimerBase } from '../../../components/disclaimer/disclaimer'
import { html } from '../../../utils/htmlParser'
import { nonNull } from '../../../utils/nonNull'
import { DisclaimerFragment } from '@gql'

export const StyledHomeDisclaimerSymbol = styled(Typography)`
  vertical-align: middle;
  font-size: ${props => props.theme.typography.pxToRem(10)};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
  padding-right: ${props => props.theme.typography.pxToRem(3)};
`

export const StyledHomeDisclaimerBase = styled(DisclaimerBase)`
  & > p {
    display: inline;
  }
`
export const StyledHomeDisclaimerWrapper = styled(DisclaimerBase)`
  background: none;
  gap: 0;
  border-radius: ${props => props.theme.typography.pxToRem(12)};

  > div:first-child {
    background: #fff;
    padding-bottom: ${props => props.theme.typography.pxToRem(35)};
  }

  > div:nth-child(2) {
    padding-top: ${props => props.theme.typography.pxToRem(25)};
    padding-bottom: 0;
    border-radius: ${props => props.theme.typography.pxToRem(12)} ${props => props.theme.typography.pxToRem(12)} 0 0;
  }

  > div:nth-child(n+3) {
    padding-bottom: 0;
  }

  > div:last-child {
    padding-bottom: ${props => props.theme.typography.pxToRem(25)};
    border-radius: 0 0 ${props => props.theme.typography.pxToRem(12)} ${props => props.theme.typography.pxToRem(12)};
  }
`
export const StyledHomeDisclaimerTitle = styled(DisclaimerBase)`
  text-align: center;
  font-size: ${props => props.theme.typography.pxToRem(14)};
  font-weight: 700;

  & > h5 {
    text-align: center;
    font-size: ${props => props.theme.typography.pxToRem(14)};
    font-weight: 700;
  }
`

export type DisclaimerProps = {
  data?: DisclaimerFragment[]
  general?: DisclaimerFragment[]
}

export const Disclaimer: React.FC<PropsWithChildren<DisclaimerProps>> = ({ data, general }) => {
  return (
    <>
      {((general && general.length > 0) || (data && data.length > 0)) &&
        <StyledHomeDisclaimerWrapper>
          <StyledHomeDisclaimerTitle id={'disclaimer_block_128'} title>{'INFORMATION YOU SHOULD KNOW'}</StyledHomeDisclaimerTitle>
          {general && nonNull(general).map((item, index) => {
            if (item.__typename === 'customDisclaimers_default_Entry' || item.__typename === 'homeLoanDisclaimers_default_Entry' || item.__typename === 'personalloandisclaimers_default_Entry') {
              return (
                <StyledHomeDisclaimerBase key={index} textBlock>
                  {item.disclaimerText && html(item.disclaimerText)}
                </StyledHomeDisclaimerBase>
              )
            }

            return null
          })}
          {data && nonNull(data).map((item, index) => {
            if (item.__typename === 'customDisclaimers_default_Entry' || item.__typename === 'homeLoanDisclaimers_default_Entry' || item.__typename === 'personalloandisclaimers_default_Entry') {
              return (
                <StyledHomeDisclaimerBase key={index} textBlock>
                  <StyledHomeDisclaimerSymbol key={index}>
                    {index + 1}
                  </StyledHomeDisclaimerSymbol>
                  {item.disclaimerText && html(item.disclaimerText)}
                </StyledHomeDisclaimerBase>
              )
            }

            return null
          })}
        </StyledHomeDisclaimerWrapper>
      }
    </>
  )
}